import { render } from "./AuthForgotConfirm.vue?vue&type=template&id=05a55ee1&scoped=true"
import script from "./AuthForgotConfirm.vue?vue&type=script&lang=js"
export * from "./AuthForgotConfirm.vue?vue&type=script&lang=js"

import "./AuthForgotConfirm.vue?vue&type=style&index=0&id=05a55ee1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a55ee1"]])

export default __exports__